'use client';

import type { ProviderEntry } from '@lib/analytics/cookie-registry';
import CountBadge from './count-badge';

type ProviderInfoProps = {
  provider: ProviderEntry;
  isExpanded: boolean;
};

const ProviderInfo = ({ provider, isExpanded }: ProviderInfoProps) => {
  if (!isExpanded) {
    return (
      <>
        <a
          href={`https://${provider.domain}`}
          target="_blank"
          rel="noopener noreferrer"
          className="font-body font-bold text-sm leading-[1.5] text-brand-neutral-900 underline decoration-solid hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-neutral-900 whitespace-nowrap self-start"
        >
          {provider.domain}
        </a>
        <CountBadge count={provider.cookies.length} />
      </>
    );
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <span className="font-body font-bold text-sm leading-[1.5] text-brand-neutral-900 whitespace-nowrap">
          {provider.name}
        </span>
        <CountBadge count={provider.cookies.length} />
      </div>
      <p className="font-body text-sm leading-[1.5] text-brand-neutral-900">
        {/* biome-ignore lint/a11y/noAmbiguousAnchorText: aria-label names the provider, so assistive tech gets the full context */}
        <a
          href={provider.privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Learn more about ${provider.name}`}
          className="font-bold underline decoration-solid hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-neutral-900"
        >
          Learn more
        </a>{' '}
        about this provider
      </p>
    </>
  );
};

export default ProviderInfo;
